import { Hiring__JobApplicationStatusEnum } from '@admin/schema';

export const getStatusBadgeClass = (status: Hiring__JobApplicationStatusEnum) => {
  switch (status) {
    case Hiring__JobApplicationStatusEnum.Started:
    case Hiring__JobApplicationStatusEnum.Submitted:
    case Hiring__JobApplicationStatusEnum.PreScreenPassed:
    case Hiring__JobApplicationStatusEnum.InterviewScheduled:
      return 'bg-info';
    case Hiring__JobApplicationStatusEnum.PreScreenFailed:
    case Hiring__JobApplicationStatusEnum.InterviewFailed:
      return 'bg-danger';
    case Hiring__JobApplicationStatusEnum.InterviewPassed:
    case Hiring__JobApplicationStatusEnum.GoogleSchedulerProvided:
      return 'bg-success';
  }
};

export const getStatusDisplayText = (status?: Hiring__JobApplicationStatusEnum) => {
  switch (status) {
    case Hiring__JobApplicationStatusEnum.Started:
      return 'Application Started';
    case Hiring__JobApplicationStatusEnum.Submitted:
      return 'Application Submitted';
    case Hiring__JobApplicationStatusEnum.PreScreenFailed:
      return 'Pre-Screen Failed';
    case Hiring__JobApplicationStatusEnum.PreScreenPassed:
      return 'Pre-Screen Passed';
    case Hiring__JobApplicationStatusEnum.GoogleSchedulerProvided:
      return 'Google Scheduler Provided';
    case Hiring__JobApplicationStatusEnum.InterviewScheduled:
      return 'Interview Scheduled';
    case Hiring__JobApplicationStatusEnum.InterviewFailed:
      return 'Interview Failed';
    case Hiring__JobApplicationStatusEnum.InterviewPassed:
      return 'Interview Passed';
  }
};
